const fuseProvisioningDetailConstants = {
  PROVISIONING_DETAIL_LOADING: "PROVISIONING_DETAIL_LOADING",
  PROVISIONING_DETAIL_SUCCESS: "PROVISIONING_DETAIL_SUCCESS",
  PROVISIONING_DETAIL_FAILURE: "PROVISIONING_DETAIL_FAILURE",
};

const fuseGetConnectivityConstants = {
  FUSE_CHECK_CONNECTIVITY_LOADING: "FUSE_CHECK_CONNECTIVITY_LOADING",
  FUSE_CHECK_CONNECTIVITY_SUCCESS: "FUSE_CHECK_CONNECTIVITY_SUCCESS",
  FUSE_CHECK_CONNECTIVITY_FAILURE: "FUSE_CHECK_CONNECTIVITY_FAILURE",
};

const fusePostConnectivityConstants = {
  FUSE_POST_CONNECTIVITY_LOADING: "FUSE_POST_CONNECTIVITY_LOADING",
  FUSE_POST_CONNECTIVITY_SUCCESS: "FUSE_POST_CONNECTIVITY_SUCCESS",
  FUSE_POST_CONNECTIVITY_FAILURE: "FUSE_POST_CONNECTIVITY_FAILURE",
};

export {
  fuseProvisioningDetailConstants,
  fuseGetConnectivityConstants,
  fusePostConnectivityConstants,
};
